<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="12" md="9">
              <v-btn
                small
                color="info"
                class="mr-4"
                @click="
                  [
                    $router.push({
                      name: 'AdministratorUsersAgentsCreate',
                    }),
                    showDialog(),
                  ]
                "
              >
                <v-icon small left>mdi-plus</v-icon>
                {{ $t("newAgent") }}
              </v-btn>
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
              <br v-if="$vuetify.breakpoint.smAndDown" />
              <v-chip
                v-show="status === 3"
                small
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3 caption' : 'ml-2'"
              >
                {{ $t("legendInactiveAgents") }}
              </v-chip>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          class="elevation-1 mb-3"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-btn x-small @click="$copy(item.id)">
              {{ item.id }}
            </v-btn>
          </template>

          <template v-slot:item.status="{ item }">
            <v-icon
              v-if="item.status == 8"
              size="16"
              color="red"
            >
              mdi-circle
            </v-icon>
            <v-icon :color="handleColorStatus(item.status)" size="16">
              mdi-circle
            </v-icon>
          </template>

          <template v-slot:item.name_agent="{ item }">
            <a
              class="blue--text"
              @click="
                $profile.showProfileDrawer(
                  item.id,
                  '/administrator/agents/getAgent'
                )
              "
            >
              <v-icon color="blue" small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
            <v-chip
              v-if="item.comissao_online"
              color="primary"
              small
              class="ml-1"
            >
              {{ $t("affiliate") }}
            </v-chip>
          </template>

          <template v-slot:item.name_local="{ item }">
            <a
              class="green--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_local,
                  '/administrator/locals/getLocal'
                )
              "
            >
              <v-icon color="green" small>mdi-account-multiple</v-icon>
              {{ item.name_local }}
            </a>
          </template>

          <template v-slot:item.name_regional="{ item }">
            <a
              class="orange--text"
              @click="
                $profile.showProfileDrawer(
                  item.id_regional,
                  'administrator/regionals/getRegional'
                )
              "
            >
              <v-icon color="orange" small>mdi-account-tie</v-icon>
              {{ item.name_regional }}
            </a>
          </template>

          <template v-slot:item.limit_retention="{ item }">
            <span class="caption">
              {{
                item.limit_retention > 9999 ? $t("unlimitedLabel") : `${$t('labelCurrency')} ${item.limit_retention}`
              }}
            </span>
          </template>

          <template v-slot:item.data_cadastro="{ item }">
            <span class="caption">{{ item.data_cadastro }}</span>
          </template>

          <template v-slot:item.action="{ item }">
            <v-btn-toggle dense>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    v-on:click="
                      $router.push({
                        name: 'AdministratorAgentBetList',
                        query: {
                          id_regional: item.id_regional,
                          id_local: item.id_local,
                          id_agent: item.id,
                        },
                      })
                    "
                  >
                    <v-icon>mdi-ticket-confirmation</v-icon>
                  </v-btn>
                </template>
                <span> {{ $t("viewBets") }} </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      $profile.showProfileDrawer(
                        item.id,
                        '/administrator/agents/getAgent'
                      )
                    "
                  >
                    <v-icon>mdi-account</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("profile") }} </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name: 'AdministratorUsersAgentsEditComissionsBets',
                          params: { id: item.id },
                        }),
                        showDialog(),
                      ]
                    "
                  >
                    <v-icon>mdi-cash-100</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("commissions") }} </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="
                      [
                        $router.push({
                          name: 'AdministratorUsersAgentsEdit',
                          params: { id: item.id },
                        }),
                        showDialog(),
                      ]
                    "
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("edit") }} </span>
              </v-tooltip>
              <MenuDropdownStatusUser
                :id_user="item.id"
                :status_user="item.status"
              />
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import MenuDropdownStatusUser from "@/components/administrator/menu/dropdownStatusUser.vue";
import HeaderPrint from "@/components/common/header-print";
export default {
  components: { MenuDropdownStatusUser, HeaderPrint },
  name: "administrator-users-agents-list",
  data: () => ({
    data: [],
    search: "",
  }),
  computed: {
    // =================================================== //
    // Translate
    // =================================================== //
    headers() {
      const headers = [
        { text: "Id", value: "id" },
        { text: this.$t("status"), value: "status" },
        { text: this.$t("name"), value: "name_agent" },
        { text: this.$t("login"), value: "login_agent" },
        { text: this.$t("mLocal"), value: "name_local" },
        { text: this.$t("mRegional"), value: "name_regional" },
      ];

      if (this.$store.state.operator && this.$store.state.operator.retail == 1) {
        headers.push({ text: this.$t("agentBalance"), value: "limit_retention" });
      }

      headers.push(
        { text: this.$t("createdIn"), value: "data_cadastro" },
        {
          text: this.$t("actions"),
          value: "action",
          align: "center d-print-none",
        }
      );

      return headers;
    },
    //
    // ====================================================
    // 2. Retrieve Values in Filters
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_local() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    // ====================================================
    // Retrieve Range (ONLY - AGENTS INACTIVES)
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_route() {
      return this.$store.state.filters.autocompleteRoutes.id;
    },
    qtd_bet() {
      return this.$store.state.filters.quantityBet.value;
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getAgentsList();
    },
    refresh(val) {
      val && this.getAgentsList();
      this.$store.commit("setRefresh", false);
    },
  },
  methods: {
    resetPage() {
      this.search = "";
    },
    async getAgentsList() {
      this.resetPage();

      // common
      const body = {
        id_regional: this.id_regional,
        id_local: this.id_local,
      };

      let endpoint = "administrator/agents/list";

      // Especial para Usuários Inativos;
      if (this.status === 3) {
        body.id_route = this.id_route;
        // body.qtd_bet = this.qtd_bet;
        // Object.assign(body, { ...this.rangeDate });
        endpoint = "administrator/agents/listInactives";
      } else {
        body.status = this.status;
        body.id_agente = this.id_agent;
      }

      const response = await this.$request.post(endpoint, body);

      this.data = response.length == 0 ? [] : response.dados;
      this.data = this.data.map((item) => {
        item.data_cadastro = new Date(
          item.data_cadastro.replace(" ", "T")
        ).toLocaleString();
        return item;
      });
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
    // handle color status
    handleColorStatus(status) {
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
    },
  },
};
</script>
